import { Route, Routes } from 'react-router-dom';
import SmartParentsProgramScreen from '../screens/Referral/SmartParentsProgram';
import SmartParentsProgramRedemptionScreen from '../screens/Referral/SmartParentsProgramRedemption';
import { ReferralRewardDetails } from '../screens/Referral/ReferralRewardDetails';
import { ReferralGuaranteedDetails } from '../screens/Referral/ResultGuaranteedDetails';
import { TryGame } from '../components/Molecules';

const SmartParentsRoute: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<SmartParentsProgramScreen />} />
      <Route path="/:region" element={<SmartParentsProgramScreen />} />
      <Route
        path="/rewardRedemption/:id"
        element={<SmartParentsProgramRedemptionScreen />}
      />
      <Route path="/referral-detail" element={<ReferralRewardDetails />} />
      <Route
        path="/guaranteed-detail"
        element={<ReferralGuaranteedDetails />}
      />
      {/* <Route path="/try-game" element={<TryGame />} />    todo uncomment this when in game is implemented */}
    </Routes>
  );
};

export default SmartParentsRoute;
